export default __webpack_public_path__ + "static/media/arm.896f701e.svg";